import * as _ from "lodash";
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { HierarchyBO } from "./HierarchyBO";
import { esWB_Hierarchy } from "../PA.Core/PAdbSchema";
import { DateUtils } from "../PA.Core/Basic/Dates";
import {
    WB_HierarchyAttributeGenerationRow,
    WB_HierarchyEntityGenerationRow
} from "../PA.Core/PAdbSchemaRows";
import { ErrorMessage_restate, WarningMessage_restate } from "../PA.Core/Basic/MessageUtils";


export class HierarchyBOValidations {

    static async ValidateEmptyFields(aBO: HierarchyBO): Promise<void> {


            if (!aBO.WB_Hierarchy.isActive)
                return;


            if (_.isEmpty(aBO.WB_Hierarchy.cif.HIERARCHY_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "Emptyname",
                        type: MessageType.Warning,
                        title: "Hierarchy Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            if (_.isEmpty(aBO.WB_Hierarchy.cif.HIERARCHY_ID) || _.isNull(aBO.WB_Hierarchy.cif.HIERARCHY_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "EmptyId",
                        type: MessageType.Warning,
                        title: "Hierarchy ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            } else {


                let sameNameHierachy = await aBO.dbContext.findAll(esWB_Hierarchy, {
                    where: {
                        HIERARCHY_ID: aBO.WB_Hierarchy.cif.HIERARCHY_ID,
                        WB_MDSET_ID: aBO.WB_Hierarchy.cif.WB_MDSET_ID,
                        ENTITY_DIMENSION: aBO.WB_Hierarchy.cif.ENTITY_DIMENSION,
                        WB_HIERARCHY_ID: { neq: aBO.WB_Hierarchy.cif.WB_HIERARCHY_ID },
                        DELETED_IND: { neq: "1" }
                    }
                });
                if (!_.isEmpty(sameNameHierachy)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: "DuplicateId",
                            type: MessageType.Error,
                            title: "Hierarchy ID is already used for the same master data set and domain",
                            description: "",
                            subtitle: "",
                            count: 0
                        });
                }
            }

            if (!(aBO.WB_Hierarchy.cif.WB_MDSET_ID > 0)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "MdSet",
                        type: MessageType.Warning,
                        title: "Master Data Set cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            if (_.isEmpty(aBO.WB_Hierarchy.cif.ENTITY_DIMENSION) || _.isNull(aBO.WB_Hierarchy.cif.ENTITY_DIMENSION)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "Domain",
                        type: MessageType.Warning,
                        title: "Master Data Domain cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(aBO.WB_Hierarchy.cif.RELATIONSHIP_TIME_POLICY) || _.isNull(aBO.WB_Hierarchy.cif.RELATIONSHIP_TIME_POLICY),
                "MaintenanceType", "Maintenance Type cannot be empty")


        if (aBO.WB_Hierarchy.cif.HIERARCHY_WORKFLOW_MODE == "LandingZone" && (_.isEmpty(aBO.WB_Hierarchy.cif.SOURCE_ID) || _.isEmpty(aBO.WB_Hierarchy.cif.EXTERNAL_HIERARCHY_ID))) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "emptyLoad",
                        type: MessageType.Warning,
                        title: "Source and External Hierarchy cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            if (!_.filter(aBO.WB_Hierarchy.WB_HierarchyLevelRows, aRow => aRow.isActive).length) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "Structure",
                        type: MessageType.Warning,
                        title: "Hierarchy Structure cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            if (_.isEmpty(_.filter(aBO.WB_Hierarchy.WB_HierarchySalesAreaRows, aRow => aRow.isActive))) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "EmptySalesArea",
                        type: MessageType.Warning,
                        title: "Hierarchy has to have at least 1 sales area",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }


            let activePeriod = _.filter(aBO.WB_Hierarchy.WB_HierarchyPeriodRows, aRow => aRow.isActive && aRow.cif.ACTIVE_IND == "1");
            if (activePeriod.length == 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "NoActivePeriod",
                        type: MessageType.Warning,
                        title: "Need one active Maintenance Period",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            if (activePeriod.length > 1) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "TooManyActivePeriod",
                        type: MessageType.Warning,
                        title: "Only can have one active Maintenance Period",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            let maintenancePeriods = _.filter(aBO.WB_Hierarchy.WB_HierarchyPeriodRows, aRow => aRow.isActive && aRow.cif.INIT_IND != "1");
            let i = 0;
            let bOverlap = false;
            while (i < maintenancePeriods.length) {
                let row = maintenancePeriods[i];

                let overlaps = _.filter(maintenancePeriods, aPeriod => {
                    if (row.cif.WB_HIERARCHYMPR_ID != aPeriod.cif.WB_HIERARCHYMPR_ID)
                        return DateUtils.RangeDatesOverlap(DateUtils.convertFromSAPBW(row.cif.PERIOD_START_DT),
                            DateUtils.convertFromSAPBW(row.cif.PERIOD_END_DT),
                            DateUtils.convertFromSAPBW(aPeriod.cif.PERIOD_START_DT),
                            DateUtils.convertFromSAPBW(aPeriod.cif.PERIOD_END_DT));
                });

                if (overlaps.length) {
                    bOverlap = true;
                    break;
                }
                i++;
            }
            if (bOverlap) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "PeriodOverlap",
                        type: MessageType.Warning,
                        title: "Maintenance Period can't overlap with each other",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            if (_.filter(aBO.WB_Hierarchy.WB_HierarchyPeriodRows, aRow => aRow.isActive && aRow.cif.PERIOD_START_DT >= aRow.cif.PERIOD_END_DT).length) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "PeriodStartGtEnd",
                        type: MessageType.Warning,
                        title: "Maintenance Period start date has to be before end date",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }


            if (_.filter(maintenancePeriods, aRow => aRow.isActive && (_.isEmpty(aRow.cif.PERIOD_NAME) || _.isEmpty(aRow.cif.PERIOD_END_DT.toString()) || _.isEmpty(aRow.cif.PERIOD_START_DT))).length) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "EmptyPeriodFields",
                        type: MessageType.Warning,
                        title: "Maintenance Period's name, start date, end date can't be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            if (aBO.WB_Hierarchy.cif.HIERARCHY_WORKFLOW_MODE !== "LandingZone" && _.includes(["Customer", "Product"], aBO.WB_Hierarchy.cif.ENTITY_DIMENSION)) {
                _.forEach(aBO.WB_Hierarchy.WB_HierarchyMDScopeRows, row => {
                    if (row.isActive) {
                        if (_.isEmpty(row.cif.ATTRIBUTE_VALUES) || _.isEmpty(row.cif.ATTRIBUTE_ID) || _.isEmpty(row.cif.OPERATION)) {
                            aBO.ValidateMessageProvider.addMessage(
                                {
                                    code: "EmptyScopeFields",
                                    type: MessageType.Error,
                                    title: "Master data scope fields can not be empty",
                                    description: "Please fill in all fields in all scope rows",
                                    subtitle: "",
                                    count: 0
                                });
                            return false;
                        }
                    }
                });
            }

            // Validations
            if (_.isEmpty(aBO.WB_Hierarchy.cif.UNBALANCED_ERROR_POLICY) || _.isEmpty(aBO.WB_Hierarchy.cif.RAGGED_ERROR_POLICY) || _.isEmpty(aBO.WB_Hierarchy.cif.ENTITY_TYPING_POLICY)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "EmptyValidationFields",
                        type: MessageType.Warning,
                        title: "Validation selections cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }

            // Build tab
            // Path field
            if (aBO.WB_Hierarchy.cif.HIERARCHY_WORKFLOW_MODE === "MasterData"
                && _.filter(aBO.WB_Hierarchy.WB_HierarchyLevelRows, aRow => aRow.isActive && aRow.cif.PATH === "").length) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: "PathEmpty",
                        type: MessageType.Warning,
                        title: "Build: Path field cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
            }


            // Start and End digit
            if (aBO.WB_Hierarchy.cif.HIERARCHY_WORKFLOW_MODE === "LandingZoneWithKey") {

                if (_.filter(aBO.WB_Hierarchy.WB_HierarchyIntelligentKeyRows, aRow => aRow.isActive && _.toNumber(aRow.cif.START_DIGIT) > _.toNumber(aRow.cif.END_DIGIT)).length) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: "StartGtEnd",
                            type: MessageType.Warning,
                            title: "Build: Start Digit has to be less than End Digit",
                            description: "",
                            subtitle: "",
                            count: 0
                        });
                } else {
                    aBO.ValidateMessageProvider.removeMessage("StartGtEnd");
                }
                if (_.filter(aBO.WB_Hierarchy.WB_HierarchyIntelligentKeyRows, aRow => aRow.isActive && (aRow.cif.START_DIGIT < 0 || aRow.cif.END_DIGIT < 0 || aRow.cif.START_DIGIT > 18 || aRow.cif.END_DIGIT > 18)).length) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: "StartOrEndInvalid",
                            type: MessageType.Warning,
                            title: "Build: Start Digit and End Digit should be between 0-18",
                            description: "",
                            subtitle: "",
                            count: 0
                        });

                } else {
                    aBO.ValidateMessageProvider.removeMessage("StartOrEndInvalid");
                }
                let activeIntelligentKeyRows = _.filter(aBO.WB_Hierarchy.WB_HierarchyIntelligentKeyRows, aRow => aRow.isActive);
                let overlapDigits = false;

                _.forEach(activeIntelligentKeyRows, (row, i) => {
                    let start = _.toNumber(row.cif.START_DIGIT);
                    let end = _.toNumber(row.cif.END_DIGIT);

                    let currentID = row.cif.WB_HIERARCHYIKR_ID;
                    let checkOverlaps = _.filter(activeIntelligentKeyRows, r => r.cif.WB_HIERARCHYIKR_ID != currentID);
                    for (let o = 0; o < checkOverlaps.length; o++) {
                        if (start === checkOverlaps[o].cif.END_DIGIT) {
                            overlapDigits = true;
                            break;
                        }
                        if (start >= checkOverlaps[o].cif.START_DIGIT && (start <= checkOverlaps[o].cif.END_DIGIT || end <= checkOverlaps[o].cif.END_DIGIT)) {
                            overlapDigits = true;
                            break;
                        }
                    }

                });
                if (overlapDigits) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: "StartEndOverlap",
                            type: MessageType.Warning,
                            title: "Build: Start Digit and End Digit range should not overlap",
                            description: "",
                            subtitle: "",
                            count: 0
                        });

                }


            }

            // Entity Generation
            if (aBO.WB_Hierarchy.cif.EXTRACT_ENTITIES_IND === "1")
                HierarchyBOValidations.mdGenerationValidations(aBO, "Entity", "Entity Generation: ");

            //Attribute Generation
            if (aBO.WB_Hierarchy.cif.EXTRACT_ATTRIBUTES_IND === "1")
                HierarchyBOValidations.mdGenerationValidations(aBO, "Attribute", "Attribute Generation: ");

    }


    static mdGenerationValidations(aBO: HierarchyBO, tableName: string, msgPrefix: string): void {

        let allRows: WB_HierarchyEntityGenerationRow[] | WB_HierarchyAttributeGenerationRow[] | any[] = tableName === "Entity" ? aBO.WB_Hierarchy.WB_HierarchyEntityRows : aBO.WB_Hierarchy.WB_HierarchyAttributeRows;
        let activeRows = _.filter(allRows, (r) => r.DELETED_IND != "1");
        let hierarchyIDs = new Set();
        let entityType = new Set();


        _.forEach(activeRows, anEntity => {
            //Hierarchy ID checks
            if (anEntity.WB_HIERARCHYLR_ID === 0) {
                if (!_.filter(aBO.ValidateMessageProvider.Messages, aMessage => aMessage.code == (tableName + "EmptyHierarchyLIDs")).length)
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: tableName + "EmptyHierarchyLIDs",
                            type: MessageType.Warning,
                            title: msgPrefix + "Hierarchy Level ID can't be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        });

            }

            hierarchyIDs.add(anEntity.cif.WB_HIERARCHYLR_ID);
            entityType.add(anEntity.cif.WB_ENTITY_ID);
            //Entity Type checks

            if (anEntity.cif.WB_ENTITY_ID === 0) {
                if (!_.filter(aBO.ValidateMessageProvider.Messages, aMessage => aMessage.code == (tableName + "EmptyEntityTypes")).length)
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: tableName + "EmptyEntityTypes",
                            type: MessageType.Warning,
                            title: msgPrefix + "Entity Type can't be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        });

            }

            if (tableName === "Entity" && Number(anEntity.cif.WB_SET_ID) === 0) {
                if (!_.filter(aBO.ValidateMessageProvider.Messages, aMessage => aMessage.code == (tableName + "EmptyKeySet")).length)
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: tableName + "EmptyKeySet",
                            type: MessageType.Warning,
                            title: msgPrefix + "Key set can't be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        });
            }

        });

        // if (activeRows.length !== hierarchyIDs.size) {
        //     aBO.ValidateMessageProvider.addMessage(
        //         {
        //             code: tableName + 'duplicateHierarchyLIds',
        //             type: MessageType.Warning,
        //             title: msgPrefix + "Duplicate Hierarchy Level IDs are not allowed",
        //             description: "",
        //             subtitle: "",
        //             count: 0
        //         })
        //
        // }


        // if (activeRows.length !== entityType.size && activeRows.length !== hierarchyIDs.size) {
        //     aBO.ValidateMessageProvider.addMessage(
        //         {
        //             code: tableName + 'duplicateEntityTypes',
        //             type: MessageType.Warning,
        //             title: msgPrefix + "Duplicate Entity Types are not allowed",
        //             description: "",
        //             subtitle: "",
        //             count: 0
        //         })
        // }

        // Check Attribute
        if (tableName !== "Attribute") {
            let attributeLevels = new Set();
            let attributes = new Set();
            _.forEach(activeRows, row => {
                if (_.toNumber(row.cif.WB_ATTRIBUTEM_ID) === 0) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: tableName + "EmptyAttribute",
                            type: MessageType.Warning,
                            title: msgPrefix + "Attribute can't be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        });

                }
                // if (_.toNumber(row.cif.WB_ATTRIBUTEM_ID_LEVEL) === 0) {
                //     aBO.ValidateMessageProvider.addMessage(
                //         {
                //             code: tableName + 'EmptyAttributeLID',
                //             type: MessageType.Warning,
                //             title: msgPrefix + "Attribute Level ID can't be empty",
                //             description: "",
                //             subtitle: "",
                //             count: 0
                //         })
                //
                // }
                attributes.add(_.toNumber(row.cif.WB_ATTRIBUTEM_ID));
                attributeLevels.add(_.toNumber(row.cif.WB_ATTRIBUTEM_ID_LEVEL));
            });
            if (activeRows.length !== attributes.size && activeRows.length !== entityType.size && activeRows.length !== hierarchyIDs.size) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: tableName + "duplicateAttributes",
                        type: MessageType.Warning,
                        title: msgPrefix + "Duplicate Attributes are not allowed",
                        description: "",
                        subtitle: "",
                        count: 0
                    });

            }
            if (activeRows.length !== attributeLevels.size && activeRows.length !== entityType.size && activeRows.length !== hierarchyIDs.size) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: tableName + "duplicateAttributeLevelIDs",
                        type: MessageType.Warning,
                        title: msgPrefix + "Duplicate Attribute Level IDs are not allowed",
                        description: "",
                        subtitle: "",
                        count: 0
                    });

            }
        }
    }

}